import Link from 'next/link';
import React from 'react';
import CustomHead from '../components/CustomHead';
import StandardLayout from '../components/StandardLayout';
import { getBlogIndexRecordMap } from '../helpers/notion/getBlogIndexRecordMap';
import { getPostSignaturesFromBlogIndexRecordMap } from '../helpers/notion/getPostSignaturesFromBlogIndexRecordMap';
import { getPageTitle } from 'notion-utils';
import { NotionPostSignature } from '../types/notion/NotionPostSignature';
import { Container } from '../components/Container';

type Props = {
  title: string;
  postSignatures: Array<NotionPostSignature>;
};

export default function BlogPage({ title, postSignatures }: Props) {
  return (
    <StandardLayout
      head={
        <CustomHead
          title="TopHouse Blog"
          description="TopHouse Real Estate Blog"
        />
      }
    >
      <Container>
        <h1 className="text-center mt-14 mb-14">{title}</h1>
        {postSignatures.map(postSignature => {
          return (
            <div key={postSignature.id} className="mb-8 ">
              <Link
                href={`/blog/${postSignature.id}`}
                className="mb-8 font-bold text-link"
              >
                {postSignature.title}
              </Link>
              <p className="text-gray-500">{postSignature.createdDate}</p>
            </div>
          );
        })}
      </Container>
    </StandardLayout>
  );
}

export async function getStaticProps() {
  const blogIndexRecordMap = await getBlogIndexRecordMap();

  const title = getPageTitle(blogIndexRecordMap);
  const postSignatures = await getPostSignaturesFromBlogIndexRecordMap(
    blogIndexRecordMap,
  );

  return {
    props: {
      postSignatures,
      title,
    },
  };
}
